/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { totalSupplyGetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGet } from "../../funcs/totalSupplyGetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema,
};

export const tool$totalSupplyGetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGet:
  ToolDefinition<typeof args> = {
    name: "total-supply-v2",
    description: `Get a series of total supply values for a ledger

Original tool name: api-v2-ledgers-ledger-canister-id-total-supply-get

### How is the data for this endpoint gathered?

Total supply is calculated by summing all mints and then subtracting all burns (including fees).`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await totalSupplyGetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };